import { type ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

export interface NavItemProps {
  to: string;
  icon: ReactNode;
  label: string;
  collapsed?: boolean;
}

export function NavItem({ to, icon, label, collapsed }: NavItemProps) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) => `
        group relative flex items-center gap-2.5 rounded px-2.5 py-1.5 text-sm
        transition-colors
        ${
          isActive
            ? 'bg-primary/10 text-primary font-medium'
            : 'text-foreground-muted hover:bg-background-hover hover:text-foreground'
        }
        ${collapsed ? 'justify-center px-2' : ''}
      `}
    >
      <span className="flex-shrink-0">{icon}</span>
      {!collapsed && <span className="truncate">{label}</span>}

      {/* Tooltip when collapsed */}
      {collapsed && (
        <div className="
          pointer-events-none absolute left-full ml-2 rounded bg-background-elevated
          px-2 py-1 text-xs text-foreground opacity-0 shadow-lg border border-border
          transition-opacity group-hover:opacity-100
          whitespace-nowrap z-50
        ">
          {label}
        </div>
      )}
    </NavLink>
  );
}
